export default "__VITE_ASSET__DC1tGR4O__"